<template>
  <!-- Main sidebar -->
  <div class="sidebar sidebar-main">
    <div class="sidebar-content">
      <!-- User menu -->
      <div class="sidebar-user-material">
        <div class="category-content pt-0">
          <!-- <div class="sidebar-user-material-content bg">
            <img
              v-if="loggedInUserData.profile_image == null"
              src="../../assets/images/Profile_avatar.png"
              class="fit-img img-circle"
              alt=""
            />
            <img
              v-else
              :src="'/images/' + loggedInUserData.profile_image"
              class="fit-img img-circle"
              alt=""
            />
            <p style="padding-top: 3px">{{ loggedInUserData.full_name }}</p>
          </div> -->

          <div class="sidebar-user-material-menu mt-0">
            <a
              href="#user-nav"
              data-toggle="collapse"
            ><span>My account</span> <i class="caret"></i></a>
          </div>
        </div>

        <div
          class="navigation-wrapper collapse"
          id="user-nav"
        >
          <ul class="navigation">
            <router-link
              class="sidebar-mobile-main-toggle"
              to="/my-profile"
              tag="li"
              active-class="active"
            ><a>
                <i
                  style="font-size: 18px"
                  class="material-icons"
                >person</i> My profile</a></router-link>
          </ul>
        </div>
      </div>
      <!-- /user menu -->

      <!-- Main navigation for KREENEX STAFF -->
      <div
        class="sidebar-category sidebar-category-visible"
        v-if="loggedInUserData.is_staff"
      >
        <div class="category-content no-padding">
          <ul class="navigation navigation-main navigation-accordion">
            <!-- Main -->
            <!-- <li class="navigation-header">
              <span>Main</span> <i class="icon-menu" title="Main pages"></i>
            </li> -->
            <!-- <li v-if="loggedInUserData.is_staff">
              <a><i style="font-size: 18px" class="material-icons">dashboard</i> <span>Dashboard</span></a>
            </li> -->
            <div class="group-title">Orders</div>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_ship_only')"
              to="/ship-only"
              tag="li"
              active-class="active"
            ><a> <i
                  style="font-size: 16px"
                  class="fa fa-plus"
                /> Ship Only</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_new_order')"
              to="/new-order"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-plus"
                />
                New Orders
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_pending_answer_order')"
              to="/pending-answer-order"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-adn"
                />
                Pending Answer
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_processed_order')"
              to="/processed_order"
              tag="li"
              active-class="active"
            ><a><i
                  style="font-size: 16px"
                  class="fa fa-cog"
                />Processed Orders</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_canceled_order')"
              to="/canceled_order"
              tag="li"
              active-class="active"
            ><a><i
                  style="font-size: 16px"
                  class="fa fa-times"
                />Canceled</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_approved_order')"
              to="/approved_order"
              tag="li"
              active-class="active"
            ><a><i
                  style="font-size: 16px"
                  class="fa fa-check"
                />Approved Orders</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_refunded_order')"
              to="/refunded_order"
              tag="li"
              active-class="active"
            ><a><i
                  style="font-size: 18px"
                  class="material-icons"
                >block</i>Refunded</a></router-link>
            <router-link
              v-if="$_has_perm('view_purchased_order')"
              class="sidebar-mobile-main-toggle"
              to="/purchased_order"
              tag="li"
              active-class="active"
            ><a><i
                  style="font-size: 18px"
                  class="material-icons"
                >add_shopping_cart</i>Purchased</a></router-link>
            <router-link
              v-if="$_has_perm('view_warehouse_delivered_order')"
              class="sidebar-mobile-main-toggle"
              to="/warehouse_delivered_order"
              tag="li"
              active-class="active"
            ><a>
                <i
                  style="font-size: 16px"
                  class="fa fa-wordpress"
                ></i> Warehouse Delivered</a></router-link>
            <router-link
              v-if="$_has_perm('view_shipment_order')"
              class="sidebar-mobile-main-toggle"
              to="/int_shipment_order"
              tag="li"
              active-class="active"
            ><a><i
                  style="font-size: 18px"
                  class="material-icons"
                >directions_boat</i>International
                Shipment</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_pending_to_branch')"
              to="/pending_to_branch_order"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 18px"
                  class="fa fa-product-hunt"
                />
                Pending To Branch
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_branch_delivered_order')"
              to="/branch_delivery_order"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 18px"
                  class="material-icons"
                >local_shipping</i>
                Branch Delivered
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_delivered_order')"
              to="/user-delivered-order"
              tag="li"
              active-class="active"
            ><a><i
                  style="font-size: 18px"
                  class="material-icons"
                >local_taxi</i>Delivered</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_exportable_order')"
              to="/exportable-order"
              tag="li"
              active-class="active"
            ><a>
                <i
                  style="font-size: 16px"
                  class="fa fa-file-excel-o"
                ></i> Exportable Orders</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_warehouse_passed_order')"
              to="/warehouse-date-passed"
              tag="li"
              active-class="active"
            ><a>
                <i
                  style="font-size: 16px"
                  class="fa fa-calendar"
                ></i>Warehouse Passed</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_all_order')"
              to="/all-order"
              tag="li"
              active-class="active"
            ><a> <i
                  style="font-size: 16px"
                  class="fa fa-cubes"
                ></i>All Orders</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_purchase_history')"
              to="/purchase-history"
              tag="li"
              active-class="active"
            ><a> <i
                  style="font-size: 16px"
                  class="fa fa-clock-o"
                ></i>Purchase History</a></router-link>

            <!-- Export Orders -->
            <hr class="my-0" />
            <hr class="my-0" />
            <div class="group-title">Export Orders</div>

            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_export_order')"
              to="/export-order/pending"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-plus"
                />
                New Export Orders
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_processed_export_order')"
              to="/export-order/processed"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-cog"
                />
                Processed
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_canceled_export_order')"
              to="/export-order/canceled"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-times"
                />
                Canceled
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_approved_export_order')"
              to="/export-order/approved"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-check"
                />
                Approved
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_sent_export_order')"
              to="/export-order/sent"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-plane"
                />
                Sent
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_received_export_order')"
              to="/export-order/received"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-check-circle"
                />
                Received
              </a>
            </router-link>
            <hr class="my-0" />
            <!-- End Export Orders -->

            <hr
              v-if="$_has_perm('send_notification')"
              class="my-0"
            />
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('send_notification')"
              to="/send-notification"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-bell"
                />
                Send Notification
              </a>
            </router-link>
            <hr class="my-0" />
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_not_found_order')"
              to="/not-found-orders"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-eye-slash"
                />
                Not Found Orders
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_order_case')"
              to="/order-cases"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-folder-open"
                />
                Order Cases
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_progress_order_case') || $_has_perm('view_order_case')"
              to="/order-case-progress"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-folder-open"
                />
                Order Cases Progress
              </a>
            </router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_order_delivery')"
              to="/order-delivery"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 16px"
                  class="fa fa-motorcycle"
                />
                Order Delivery
              </a>
            </router-link>
            <hr
              v-if="$_has_perm('view_not_found_order') || $_has_perm('view_order_case')"
              class="my-0"
            />
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_staff')"
              to="/users"
              tag="li"
              active-class="active"
            ><a><i
                  style="font-size: 18px"
                  class="material-icons"
                >group</i>Staff</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_customer')"
              to="/regular-user"
              tag="li"
              active-class="active"
            ><a><i
                  style="font-size: 18px"
                  class="material-icons"
                >person</i>Customer</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_loaned_customer')"
              to="/loan-customers"
              tag="li"
              active-class="active"
            ><a><i
                  style="font-size: 18px"
                  class="material-icons"
                >person</i>Loaned customer</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_credit')"
              to="/secret?component=credit"
              tag="li"
              active-class="active"
            ><a><i
                  style="font-size: 18px"
                  class="material-icons"
                >attach_money</i>Customer
                Credit</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_coupon')"
              to="/secret?component=coupon"
              tag="li"
              active-class="active"
            ><a><i
                  class="fa fa-credit-card-alt"
                  style="font-size: 16px"
                ></i>Coupons</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_supplier')"
              to="/supplier"
              tag="li"
              active-class="active"
            ><a><i
                  class="fa fa-users"
                  style="font-size: 16px"
                ></i>Suppliers</a></router-link>
            <hr class="my-0" />
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_shipping_invoice')"
              to="/order_invoice"
              tag="li"
              active-class="active"
            ><a><i
                  class="fa fa-file-text-o"
                  style="font-size: 16px"
                ></i>Shipping Invoice</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_order_invoice')"
              to="/secret?component=credit-log-transaction"
              tag="li"
              active-class="active"
            ><a><i
                  class="fa fa-file-text-o"
                  style="font-size: 16px"
                ></i>Order Invoice</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_credit')"
              to="/secret?component=credit-log-action"
              tag="li"
              active-class="active"
            ><a><i
                  class="fa fa-file-text-o"
                  style="font-size: 16px"
                ></i>Credit Invoice</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_partial_refund')"
              to="/secret?component=partial-refund"
              tag="li"
              active-class="active"
            ><a><i
                  class="fa fa-file-text-o"
                  style="font-size: 16px"
                ></i>Partial Refund Invoice</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_delivery_invoice')"
              to="/secret?component=delivery-invoice"
              tag="li"
              active-class="active"
            ><a><i
                  class="fa fa-motorcycle"
                  style="font-size: 16px"
                ></i>Delivery Invoice</a></router-link>
            <hr class="my-0" />
            <!-- <li v-if="$_has_perm('')">
              <a href=""><i style="font-size: 18px" class="material-icons">swap_horiz</i><span>Transactions</span></a>
              <ul>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  to="/secret?component=credit-log-transaction"
                  tag="li"
                  active-class="active"
                ><a>Order Invoice</a></router-link>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  to="/secret?component=credit-log-action"
                  tag="li"
                  active-class="active"
                ><a>Credit</a></router-link>
              </ul>
            </li> -->
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_expense_type')"
              to="/secret?component=expense-type"
              tag="li"
              active-class="active"
            ><a><i
                  class="fa fa-file-text"
                  style="font-size: 16px"
                ></i>Expense Type</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_expense')"
              to="/secret?component=expense"
              tag="li"
              active-class="active"
            ><a><i
                  class="fa fa-eur"
                  style="font-size: 16px"
                ></i>Expenses</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_money_transfer')"
              to="/secret?component=money-transfer"
              tag="li"
              active-class="active"
            ><a><i
                  class="fa fa-share"
                  style="font-size: 16px"
                ></i>Money Transfer</a></router-link>
            <hr class="my-0" />
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_money')"
              to="/secret?component=put_money"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  class="fa fa-plus"
                  style="font-size: 16px"
                />
                Add Money
              </a>
            </router-link>
            <!-- <hr class="my-0"> -->
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_capital')"
              to="/secret?component=capital"
              tag="li"
              active-class="active"
            ><a><i
                  class="fa fa-database"
                  style="font-size: 16px"
                ></i>Capital</a></router-link>
            <!-- <hr class="my-0"> -->
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_profit')"
              to="/secret?component=profit"
              tag="li"
              active-class="active"
            ><a><i
                  class="fa fa-pie-chart"
                  style="font-size: 16px"
                ></i>Profit</a></router-link>
            <hr class="my-0" />
            <router-link
              v-if="$_has_perm('view_order_log')"
              class="sidebar-mobile-main-toggle"
              to="/secret?component=order-log"
              tag="li"
              active-class="active"
            ><a>
                <i
                  style="font-size: 18px"
                  class="material-icons"
                >swap_vert</i>
                Order Log
              </a>
            </router-link>
            <hr class="my-0" />
            <!-- <li v-if="$_has_perm('')">
              <a href=""><i style="font-size: 18px" class="material-icons">swap_vert</i><span>Log</span></a>
              <ul>
                <router-link
                  class="sidebar-mobile-main-toggle"
                  to="/secret?component=order-log"
                  tag="li"
                  active-class="active"
                ><a>Order Log</a></router-link>
              </ul>
            </li> -->
            <!-- <li>
              <a href=""><i
                  class="fa fa-money"
                  style="font-size: 16px"
                ></i><span>Prices</span></a>
              <ul> -->
            <router-link
              v-if="$_has_perm('view_customer_price')"
              class="sidebar-mobile-main-toggle"
              to="/secret?component=customer-prices"
              tag="li"
              active-class="active"
            ><a><i
                  class="fa fa-money"
                  style="font-size: 16px"
                ></i>Customer prices</a></router-link>
            <router-link
              v-if="$_has_perm('view_company_fee')"
              class="sidebar-mobile-main-toggle"
              to="/secret?component=kreenex-fee-prices"
              tag="li"
              active-class="active"
            ><a><i
                  class="fa fa-money"
                  style="font-size: 16px"
                ></i>ShipZone Fee</a></router-link>
            <hr class="my-0" />
            <!-- <router-link
                  class="sidebar-mobile-main-toggle"
                  to="/secret?component=shipping-prices"
                  tag="li"
                  active-class="active"
                  ><a>Shipping price (Turkey)</a></router-link
                > -->
            <!-- </ul>
            </li> -->
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_bank')"
              to="/banks"
              tag="li"
              active-class="active"
            ><a><i
                  style="font-size: 18px"
                  class="material-icons"
                >account_balance</i>Banks</a></router-link>
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_currency_rate')"
              to="/currency-rate"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  style="font-size: 18px"
                  class="material-icons"
                >
                  loop
                </i>
                Currency Rates
              </a>
            </router-link>
            <!-- <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_exchange_rate')"
              to="/exchange-rate"
              tag="li"
              active-class="active"
            ><a><i
                  style="font-size: 18px"
                  class="material-icons"
                >loop</i>Exchange rates</a></router-link> -->
            <router-link
              class="sidebar-mobile-main-toggle"
              v-if="$_has_perm('view_delivered_report')"
              to="/delivered-report"
              tag="li"
              active-class="active"
            ><a><i class="fa fa-line-chart pl-2"></i>Delivered report</a></router-link>

            <hr class="my-0" />

            <router-link
              v-if="$_has_perm('view_role')"
              class="sidebar-mobile-main-toggle"
              to="/roles"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  class="fa fa-shield pl-2"
                  style="font-size: 16px"
                />
                Roles
              </a>
            </router-link>
            <!-- <router-link
              v-if="$_has_perm('view_branch')"
              class="sidebar-mobile-main-toggle"
              to="/branch"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  class="fa fa-home pl-2"
                  style="font-size: 16px"
                />
                Branches
              </a>
            </router-link> -->

            <hr class="my-0" />

            <router-link
              v-if="$_has_perm('view_city')"
              class="sidebar-mobile-main-toggle"
              to="/city"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  class="fa fa-home pl-2"
                  style="font-size: 16px"
                />
                Cities
              </a>
            </router-link>

            <hr
              v-if="$_has_perm('view_home_slider')"
              class="my-0"
            />

            <router-link
              v-if="$_has_perm('view_home_slider')"
              class="sidebar-mobile-main-toggle"
              to="/home-slider"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  class="fa fa-image pl-2"
                  style="font-size: 16px"
                />
                Home Slider
              </a>
            </router-link>

            <router-link
              v-if="$_has_perm('view_popular_website')"
              class="sidebar-mobile-main-toggle"
              to="/popular-website"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  class="fa fa-globe pl-2"
                  style="font-size: 16px"
                />
                Popular Websites
              </a>
            </router-link>

            <router-link
              v-if="$_has_perm('view_global_website')"
              class="sidebar-mobile-main-toggle"
              to="/global-website-group"
              tag="li"
              active-class="active"
            >
              <a>
                <i
                  class="fa fa-globe pl-2"
                  style="font-size: 16px"
                />
                Global Websites
              </a>
            </router-link>
          </ul>
        </div>
      </div>
      <!-- /main navigation for kreenex staff -->

      <!-- Main navigation for KREENEX CUSTOMER -->
      <div v-if="!loggedInUserData.is_staff">
        <div
          class="sidebar-category sidebar-category-visible"
          v-if="loggedInUserData.phone_number && loggedInUserData.address"
        >
          <div class="category-content no-padding">
            <ul class="navigation navigation-main navigation-accordion">
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/make-new-ship-only"
                tag="li"
                active-class="active"
              ><a>
                  <i
                    style="font-size: 18px"
                    class="material-icons"
                  >add</i>
                  <span>Ship Only</span></a></router-link>
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/make-new-order"
                tag="li"
                active-class="active"
              >
                <a>
                  <i
                    style="font-size: 18px"
                    class="material-icons"
                  >add_box</i>
                  <span>New Order</span>
                </a>
              </router-link>
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/my-order"
                tag="li"
                active-class="active"
              ><a>
                  <i
                    style="font-size: 18px"
                    class="material-icons"
                  >filter_none</i>
                  <span>Orders</span></a></router-link>
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/my-order-cases"
                tag="li"
                active-class="active"
              >
                <a>
                  <i
                    style="font-size: 16px"
                    class="fa fa-folder-open"
                  />
                  Order Cases
                </a>
              </router-link>
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/archived-order"
                tag="li"
                active-class="active"
              >
                <a>
                  <i
                    style="font-size: 18px"
                    class="material-icons"
                  >
                    archive
                  </i>
                  Archived Orders
                </a>
              </router-link>
              <!-- <router-link
                class="sidebar-mobile-main-toggle"
                to="/charge-balance"
                tag="li"
                active-class="active"
              >
                <a>
                  <i
                    style="font-size: 18px"
                    class="fa fa-money"
                  />
                  Charge Balance
                </a>
              </router-link> -->
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/check-rate"
                tag="li"
                active-class="active"
              >
                <a>
                  <i
                    style="font-size: 18px"
                    class="fa fa-money"
                  />
                  Check Rate
                </a>
              </router-link>
              <router-link
                class="sidebar-mobile-main-toggle"
                to="/my-export-order"
                tag="li"
                active-class="active"
              >
                <a>
                  <i
                    style="font-size: 18px"
                    class="fa fa-file"
                  />
                  Export Order
                </a>
              </router-link>
              <li>
                <a href=""><i
                    style="font-size: 18px"
                    class="material-icons"
                  >assignment</i><span>Invoices</span></a>
                <ul>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    to="/customer-invoice"
                    tag="li"
                    active-class="active"
                  ><a>Order Invoices</a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    to="/customer-order-invoice"
                    tag="li"
                    active-class="active"
                  ><a>Shipping Invoices</a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    to="/customer-credit-invoice"
                    tag="li"
                    active-class="active"
                  ><a>Credit Invoices</a></router-link>
                  <router-link
                    class="sidebar-mobile-main-toggle"
                    to="/customer-partial-refund"
                    tag="li"
                    active-class="active"
                  ><a>Partial Refund Invoices</a></router-link>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- /main navigation for KREENEX CUSTOMER -->
    </div>
  </div>
  <!-- /main sidebar -->
</template>

<script>
export default {
  props: ['loggedInUserData']
}
</script>
<style>
.bg {
  height: 150px;
  width: 220px;
}
.fit-img {
  width: 62%;
  height: 90%;
}

.sidebar-content {
  height: 94vh;
  overflow: scroll;
}
.group-title {
  font-size: 14px;
  text-transform: uppercase;
  font-weight: bold;
  opacity: 0.8;
  padding: 6px 8px;
  margin-top: 8px;
  letter-spacing: 1.1px;
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar.vue